angular.module('angus.controllers').controller('copyLayoutController', [
    '$q', '$rootScope', '$scope', 'adminService','subscriberService','usersService', 'widgetService', 'gridState', `toastService`,
    function ($q, $rootScope, $scope, adminService,subscriberService, usersService, widgetService, gridState, toastService) {

        $scope.settings = {};
        $scope.sourceWidgets = [];
        $scope.isSysAdmin = !!$rootScope.user.isSysAdmin;
        $scope.submit = submit;
        $scope.sourceSubscriberChanged = sourceSubscriberChanged;
        $scope.destinationSubscriberChanged = destinationSubscriberChanged;
        $scope.destinationUserChanged = destinationUserChanged;
        $scope.sourceUserChanged = sourceUserChanged;
        $scope.isSubmitDisabled = isSubmitDisabled;
        $scope.allSelected = allSelected;
        $scope.toggleSelectAllWidgets = toggleSelectAllWidgets;

        function init() {
            getSubscribers();
            getWidgets();

        }

       function toggleSelectAllWidgets() {
            if ($scope.allSelected()) {
                // Deselect all
                $scope.settings.sourceWidgetCodes = [];
            } else {
                $scope.settings.sourceWidgetCodes = $scope.sourceWidgets.map(w => w.code);
            }
        };

        function allSelected () {
            return $scope.sourceWidgets.length &&
                $scope.settings.sourceWidgetCodes.length === $scope.sourceWidgets.length;
        };

        function sourceSubscriberChanged() {
            getSubscribersUsers($scope.settings.sourceSelectedSubscriberKey, "source");
        };

        function sourceUserChanged() {
            getUsersWidgetsWithLayout($scope.settings.sourceSelectedSubscriberKey, "source");
        };

        function destinationSubscriberChanged(){
            getSubscribersUsers($scope.settings.destinationSelectedSubscriberKey,"destination");
        };

        function destinationUserChanged(){
            if($scope.settings.sourceSelectedUserId === $scope.settings.destinationSelectedUserId){
                $scope.formAlert.$invalid = true;
                toastService.addToast(toastService.types.danger, "Cannot select the same as source user");
            }else{
                $scope.formAlert.$invalid = false;
            }
        }

        function isSubmitDisabled(){

            return $scope.formAlert.$invalid
                || $scope.isSaving
                || !$scope.settings.sourceSelectedUserId
                || !$scope.settings.destinationSelectedUserId
                || !$scope.settings.sourceWidgetCodes;
         }

        function getUsersWidgetsWithLayout() {
            $scope.areWidgetsLoading = true;
            $scope.sourceWidgets = [];
            $scope.settings.sourceWidgetCodes = [];
            
            gridState().getGridStateWidgetCodes($scope.settings.sourceSelectedUserId)
                .then(function(usersGridStateWidgetCode) {

                    $scope.sourceWidgets = $scope.widgets
                        .filter(widget => usersGridStateWidgetCode.includes(widget.code));

                    if($scope.sourceWidgets.length < 1){
                        toastService.addToast(toastService.types.danger, "Source User has no widgets with a layout");
                    }

                    $scope.areWidgetsLoading = false;
                }).catch(function(){
                    $scope.sourceWidgets = [];
                    $scope.areWidgetsLoading = false;
                });
        }

        function getSubscribersUsers(subscriberKey,target) {
            if(target === "source"){
                $scope.areSourceUsersLoading = true;
            }else if(target === "destination"){
                $scope.areDestinationUsersLoading = true;
            }

            usersService.getSubscribersUsers(subscriberKey)
                .then(data => {
                    if(target === "source"){
                        $scope.sourceUsers = data;
                        $scope.areSourceUsersLoading = false;
                    }else if(target === "destination"){
                        $scope.destinationUsers = data;
                        $scope.areDestinationUsersLoading = false;
                    }
                }).catch(function(){
                    if(target === "source"){
                    $scope.aresourceUsersLoading = false;
                    }else if(target === "destination"){
                    $scope.aredestinationUsersLoading = false;
                    }
            });

        }

        function getSubscribers() {
            $scope.areSubscribersLoading = true;

            return subscriberService.getAllLive()
                .then(data => {
                    $scope.sourceSubscribers = data;
                    $scope.destinationSubscribers = data;

                    $scope.areSubscribersLoading = false;
                }).catch(function(){
                    $scope.areSubscribersLoading = false;
                });
        }

        function getWidgets(){
            widgetService.getWidgetsLegacy()
                .then(function(widgets){
                    $scope.widgets = widgets.sort((a, b) => a.name.localeCompare(b.name));
                });
        }

        function submit() {
            if ($scope.formAlert.$invalid) {
                return;
            }
            $scope.isSaving = true;

            gridState().createLegacyCopy($scope.settings.destinationSelectedUserId, $scope.settings.sourceSelectedUserId, $scope.settings.sourceWidgetCodes)
                .then(function (data) {
                    $scope.isSaving = false;
                    toastService.addToast(toastService.types.success, 'Layout Copy created successfully', 5000);
                }).catch(function(){
                    $scope.isSaving = false;
                });
        }

        init();
    }
]);